// Survey Audit Query Keys following React Query best practices
export const surveyAuditQueryKeys = {
  // Base keys
  all: ['survey-audits'] as const,
  audits: () => [...surveyAuditQueryKeys.all, 'audits'] as const,
  audit: (auditId: string) => [...surveyAuditQueryKeys.audits(), auditId] as const,

  // List queries
  list: (filters?: Record<string, unknown>) =>
    [...surveyAuditQueryKeys.audits(), 'list', filters] as const,
  listBySurveyInstance: (surveyInstanceId: string) =>
    [...surveyAuditQueryKeys.audits(), 'survey-instance', surveyInstanceId] as const,
  listBySubject: (subjectId: string, status?: string | string[]) =>
    [...surveyAuditQueryKeys.audits(), 'subject', subjectId, { status }] as const,
  listByTenant: (tenantId: string) =>
    [...surveyAuditQueryKeys.audits(), 'tenant', tenantId] as const,

  // Detail queries
  detail: (auditId: string) => [...surveyAuditQueryKeys.audit(auditId), 'detail'] as const,
  progress: (auditId: string) => [...surveyAuditQueryKeys.audit(auditId), 'progress'] as const,
  trail: (auditId: string) => [...surveyAuditQueryKeys.audit(auditId), 'trail'] as const,
  statistics: (auditId: string) => [...surveyAuditQueryKeys.audit(auditId), 'statistics'] as const,

  // Questions and responses
  questions: (auditId: string) => [...surveyAuditQueryKeys.audit(auditId), 'questions'] as const,
  questionResponses: (auditId: string, questionId: string) =>
    [...surveyAuditQueryKeys.questions(auditId), questionId, 'responses'] as const,

  // Permissions
  permissions: (userId: string, subjectId: string) =>
    [...surveyAuditQueryKeys.all, 'permissions', userId, subjectId] as const,
} as const;
